import React, { BaseSyntheticEvent, useMemo } from 'react';
import { EditorWrapper } from '../styles';
import { SectionTitle } from '../styles';
import { ProjectAddButton } from 'shared/pages/projectEdit/ProjectAddButton';
import { useTranslation } from 'react-i18next';
import { createDefaultLangObject } from 'shared/components/__ADDONS__/__SAFEAPI__/Defaults';
import { GroupsInputs } from '../components/Inputs/GroupsInputs';
import { LangObjectArray } from '@brg/api/dist/api-core/utils/lang-utils';
import setTextByLang from 'shared/helpers/setTextByLang';
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import SortableList, { SortableItem } from 'react-easy-sort';
import { ApplicationEditorActions, ApplicationEditorSelector } from 'shared/reducers/ApplicationEditorSlice';
import { useDispatch, useSelector } from 'react-redux';
import { FormFieldType, MAX_DOCS_COUNT } from '../constants';
import { API } from '@brg/api';
import { FlexBox } from '@brg/ui';

const DocsEditor: React.FC<{}> = ({
}) => {
    const { t } = useTranslation();
    const { docs: fields } = useSelector(ApplicationEditorSelector);
    const dispatch = useDispatch();
    const action = ApplicationEditorActions;

    const onAddField = () => {
      if (fields.length >= MAX_DOCS_COUNT) return;
      dispatch(action.addDoc({
        type: FormFieldType.LegalDocument,
        header: createDefaultLangObject(' '),
        placeholder: createDefaultLangObject(' '),
        isRequired: false,
        inlineVariants: [],
        fieldIdInCrm: 0,
        isTagInCrm: false,
        isDisabled: false,
        url: '',
        additionalInfo: {
          textAfter: JSON.stringify(createDefaultLangObject('')),
          textBefore: JSON.stringify(createDefaultLangObject('')),
          text: JSON.stringify(createDefaultLangObject('')),
        }
      }));
    }

      const onDeleteField = (index: number) => {
        dispatch(action.removeDoc(index));
      };
    
      const onSortEnd = (oldIndex: number, newIndex: number) => {
        const newData = arrayMoveImmutable(fields, oldIndex, newIndex);
        dispatch(action.setDocs(newData));
      };
    
      const onSwitchChange = (index: number, value: number | boolean) => {
        // react-input-switch вызывает onChange с boolean; при сравнении value === 1 true никогда не совпадает с 1
        const disabled = !(value === 1 || value === true);
        const newData = fields.map((field, i) => (i === index ? { ...field, isDisabled: disabled } : field));
        dispatch(action.setDocs(newData));
      };
    
      const onRequiredChange = (index: number, value: boolean) => {
        const newData = fields.map((field, i) => i === index ? { ...field, isRequired: value } : field);
        dispatch(action.setDocs(newData));
      };
    
      const onUpdateField = (index: number, ev: BaseSyntheticEvent, lang?: string) => {
        const key = ev?.target?.name;
        const value = ev?.target?.value;
        const prevValue = fields.find((field, i) => i === index)?.[key as keyof typeof fields[0]] as LangObjectArray;
        const prevAdditionalInfo = JSON.parse(fields.find((field, i) => i === index)?.additionalInfo?.[key] as any || '{}') || [];
        if (key && ['textBefore', 'textAfter', 'text'].includes(key)) {
          const newData = fields.map((field, i) => i === index ? { ...field, additionalInfo: { ...field.additionalInfo, [key]: JSON.stringify(setTextByLang(prevAdditionalInfo, lang ?? 'ru', value ?? '')) } } : field);
          dispatch(action.setDocs(newData));
          return
        }
        if (!lang) {
          const newData = fields.map((field, i) => i === index ? { ...field, [key as keyof typeof fields[0]]: value } : field);
          dispatch(action.setDocs(newData));
          return
        }
        const newData = fields.map((field, i) => i === index ? { ...field, [key]: setTextByLang(prevValue, lang, value) } : field);
        dispatch(action.setDocs(newData));
      };
      
  return (
    <EditorWrapper gy={24}>
      <SectionTitle>{t('applicationEditor.sections.fields.docs_title')}</SectionTitle>
      <SortableList
        as={'div'}
        onSortEnd={onSortEnd}
        lockAxis="y"
        draggedItemClassName="application-editor-sortable-dragged"
      >
        <FlexBox gy={24} direction="column">
          {fields?.map((item, index) => (
            <SortableItem key={"fields-editor-sortable_" + index}>
              <GroupsInputs 
                index={index} 
                type={item.type} 
                url={item.url}
                placeholder={item.placeholder} 
                isDisabled={item.isDisabled} 
                header={item.header} 
                isRequired={item.isRequired} 
                additionalInfo={item.additionalInfo}
                onChange={onUpdateField} onDeleteField={onDeleteField} onSwitchChange={onSwitchChange} onRequiredChange={onRequiredChange} />
            </SortableItem>
          ))}
        </FlexBox>
    </SortableList>
     
      <ProjectAddButton 
        disable={fields.length >= MAX_DOCS_COUNT} 
        reverse 
        onClick={onAddField} 
        hideIcon={fields.length >= MAX_DOCS_COUNT}
        text={t('teams.adminPage.fields.form_add_field')} 
      />
    </EditorWrapper>
  );
};

export default DocsEditor;import React, { BaseSyntheticEvent, useMemo } from 'react';
import { EditorWrapper } from '../styles';
import { SectionTitle } from '../styles';
import { ProjectAddButton } from 'shared/pages/projectEdit/ProjectAddButton';
import { useTranslation } from 'react-i18next';
import { createDefaultLangObject } from 'shared/components/__ADDONS__/__SAFEAPI__/Defaults';
import { GroupsInputs } from '../components/Inputs/GroupsInputs';
import { LangObjectArray } from '@brg/api/dist/api-core/utils/lang-utils';
import setTextByLang from 'shared/helpers/setTextByLang';
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import SortableList, { SortableItem } from 'react-easy-sort';
import { ApplicationEditorActions, ApplicationEditorSelector } from 'shared/reducers/ApplicationEditorSlice';
import { useDispatch, useSelector } from 'react-redux';
import { FormFieldType, MAX_DOCS_COUNT } from '../constants';
import { API } from '@brg/api';
import { FlexBox } from '@brg/ui';

const DocsEditor: React.FC<{}> = ({
}) => {
    const { t } = useTranslation();
    const { docs: fields } = useSelector(ApplicationEditorSelector);
    const dispatch = useDispatch();
    const action = ApplicationEditorActions;

    const onAddField = () => {
      if (fields.length >= MAX_DOCS_COUNT) return;
      dispatch(action.addDoc({
        type: FormFieldType.LegalDocument,
        header: createDefaultLangObject(' '),
        placeholder: createDefaultLangObject(' '),
        isRequired: false,
        inlineVariants: [],
        fieldIdInCrm: 0,
        isTagInCrm: false,
        isDisabled: false,
        url: '',
        additionalInfo: {
          textAfter: JSON.stringify(createDefaultLangObject('')),
          textBefore: JSON.stringify(createDefaultLangObject('')),
          text: JSON.stringify(createDefaultLangObject('')),
        }
      }));
    }

      const onDeleteField = (index: number) => {
        dispatch(action.removeDoc(index));
      };
    
      const onSortEnd = (oldIndex: number, newIndex: number) => {
        const newData = arrayMoveImmutable(fields, oldIndex, newIndex);
        dispatch(action.setDocs(newData));
      };
    
      const onSwitchChange = (index: number, value: number | boolean) => {
        // react-input-switch вызывает onChange с boolean; при сравнении value === 1 true никогда не совпадает с 1
        const disabled = !(value === 1 || value === true);
        const newData = fields.map((field, i) => (i === index ? { ...field, isDisabled: disabled } : field));
        dispatch(action.setDocs(newData));
      };
    
      const onRequiredChange = (index: number, value: boolean) => {
        const newData = fields.map((field, i) => i === index ? { ...field, isRequired: value } : field);
        dispatch(action.setDocs(newData));
      };
    
      const onUpdateField = (index: number, ev: BaseSyntheticEvent, lang?: string) => {
        const key = ev?.target?.name;
        const value = ev?.target?.value;
        const prevValue = fields.find((field, i) => i === index)?.[key as keyof typeof fields[0]] as LangObjectArray;
        const prevAdditionalInfo = JSON.parse(fields.find((field, i) => i === index)?.additionalInfo?.[key] as any || '{}') || [];
        if (key && ['textBefore', 'textAfter', 'text'].includes(key)) {
          const newData = fields.map((field, i) => i === index ? { ...field, additionalInfo: { ...field.additionalInfo, [key]: JSON.stringify(setTextByLang(prevAdditionalInfo, lang ?? 'ru', value ?? '')) } } : field);
          dispatch(action.setDocs(newData));
          return
        }
        if (!lang) {
          const newData = fields.map((field, i) => i === index ? { ...field, [key as keyof typeof fields[0]]: value } : field);
          dispatch(action.setDocs(newData));
          return
        }
        const newData = fields.map((field, i) => i === index ? { ...field, [key]: setTextByLang(prevValue, lang, value) } : field);
        dispatch(action.setDocs(newData));
      };
      
  return (
    <EditorWrapper gy={24}>
      <SectionTitle>{t('applicationEditor.sections.fields.docs_title')}</SectionTitle>
      <SortableList
        as={'div'}
        onSortEnd={onSortEnd}
        lockAxis="y"
        draggedItemClassName="application-editor-sortable-dragged"
      >
        <FlexBox gy={24} direction="column">
          {fields?.map((item, index) => (
            <SortableItem key={"fields-editor-sortable_" + index}>
              <GroupsInputs 
                index={index} 
                type={item.type} 
                url={item.url}
                placeholder={item.placeholder} 
                isDisabled={item.isDisabled} 
                header={item.header} 
                isRequired={item.isRequired} 
                additionalInfo={item.additionalInfo}
                onChange={onUpdateField} onDeleteField={onDeleteField} onSwitchChange={onSwitchChange} onRequiredChange={onRequiredChange} />
            </SortableItem>
          ))}
        </FlexBox>
    </SortableList>
     
      <ProjectAddButton 
        disable={fields.length >= MAX_DOCS_COUNT} 
        reverse 
        onClick={onAddField} 
        hideIcon={fields.length >= MAX_DOCS_COUNT}
        text={t('teams.adminPage.fields.form_add_field')} 
      />
    </EditorWrapper>
  );
};

export default DocsEditor;